(function() {

  class FactsSlider {
    constructor(element) {
      if(!element || element.classList.contains('u-module--initialized')) return;

      element.classList.add('u-module--initialized');

      this.element = element;
      this.itemsCount = element.querySelectorAll('.u-facts-slider__item').length;
      this.hasArrows = this.itemsCount > 3;
      this.init();

      var event = new CustomEvent('generate-smooth-scroll-links', { detail: element });
      document.dispatchEvent(event);
    }

    init() {
      this.splide = new Splide(this.element, {
        autoWidth: true,
        arrows: this.hasArrows,
        gap: '3.3125rem',
        breakpoints: {
          1439: {
            gap: '3rem',
          },
          1183: {
            gap: '4rem',
          },
        },
        type: 'loop'
      })
      
      this.splide.on('mounted', () => {
        this.refreshSliderArrows();
        this.refreshSliderPagination();
      } );
      this.splide.on('move', () => {
        this.element.classList.add('u-animation--disabled');
      } );

      this.splide.on('pagination:mounted', () => {
        console.log('pagination:mounted');
        this.element.closest('.u-facts-slider__wrapper').querySelector('.u-facts-slider__pagination').appendChild(this.splide.Components.Pagination.data.list);

        setTimeout(() => {
          var event = new CustomEvent('inview-css-variables');
          document.dispatchEvent(event);
        }, 1000)
      });

      window.addEventListener('resize', () => {
        this.refreshSliderArrows();
        this.refreshSliderPagination()
      });

      this.splide.mount();
    }

    refreshSliderArrows() {
      setTimeout(() => {
        if (this.hasArrows && this.splide.Components.Arrows) {
          const arrowsContainer = this.element.closest('.u-facts-slider__wrapper').querySelector('.u-facts-slider__arrows');
          arrowsContainer.appendChild(this.splide.Components.Arrows.arrows.next);
          arrowsContainer.appendChild(this.splide.Components.Arrows.arrows.prev);
        }
      });
    }


    refreshSliderPagination() {
      let elements = [].slice.call(this.element.querySelectorAll('.splide__slide[id]'), 0);
      let space = elements.length > 0 ? (elements.length - 1) * parseInt(elements[0].style.marginRight) : 0;

      let trackWidth = elements.map(function(item) { return item.clientWidth }).reduce(function(a,b){
        return a + b
      }, 0) + space;

      // + 2px for rendering bug
      if ( this.element.querySelector('.splide__track').clientWidth + 2 >= trackWidth ) {
        this.splide.options = { drag: false };
        this.element.closest('.u-facts-slider__wrapper').querySelector('.u-facts-slider__pagination').classList.remove('is-visible')
      } else {
        this.splide.options = { drag: true };
        this.element.closest('.u-facts-slider__wrapper').querySelector('.u-facts-slider__pagination').classList.add('is-visible')
      }
    }
  }

  function initAll(parent) {
    const elements = parent.querySelectorAll('.u-facts-slider .splide');

    for (const element of elements) {
      new FactsSlider(element)
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    initAll(document);
  });
  
  document.addEventListener('overlay-content-ready', function () {
    initAll(document.querySelector('.u-overlay__content'));
  });

})();